import { useSelector } from 'react-redux'
import { FormFieldSqFt } from '../../..'
import { FilterSection } from '../FilterSection'
import { defineMessages, useIntl } from 'react-intl'
import { selectFilter } from '../../../../store/selectors/filters'
import { ACRES_SUFFIX, MAX_ACRES, MIN_ACRES } from '../../../../constants/listings'
import { Box, Flex } from '@homebotapp/hb-react-component-catalog'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.lotSize.heading',
    defaultMessage: 'Lot Size (Acres)'
  },
  min: {
    id: 'General.minimum',
    defaultMessage: 'Minimum'
  },
  max: {
    id: 'General.maximum',
    defaultMessage: 'Maximum'
  }
})

export const LotSize = () => {
  const intl = useIntl()
  const filters = useSelector(selectFilter)

  return (
    <FilterSection title={intl.formatMessage(MSG.heading)}>
      <Flex gap={4} align='center' maxW='19rem'>
        <FormFieldSqFt
          name={MIN_ACRES}
          suffix={ACRES_SUFFIX}
          allowNegative={false}
          value={filters[MIN_ACRES] || undefined}
        >
          {intl.formatMessage(MSG.min)}
        </FormFieldSqFt>
        <Box mt={4}>{'—'}</Box>
        <FormFieldSqFt
          name={MAX_ACRES}
          suffix={ACRES_SUFFIX}
          allowNegative={false}
          value={filters[MAX_ACRES] || undefined}
        >
          {intl.formatMessage(MSG.max)}
        </FormFieldSqFt>
      </Flex>
    </FilterSection>
  )
}

LotSize.parseValue = (unsafeValue: string) => {
  const unparsedValue = unsafeValue.replace(/[ac,\s]/g, '')
  return parseFloat(unparsedValue)
}
